import { createContext, useContext, useState } from "react";

const FavoriteContext = createContext();

export const FavoriteProvider = ({ children }) => {
  const [favoriteEvent, setFavoriteEvent] = useState(null);

  const triggerFavoriteEvent = (propertyId, action) => {
    setFavoriteEvent({
      propertyId,
      action, // "like" or "dislike"
      time: Date.now(),
    });
  };

  return (
    <FavoriteContext.Provider value={{ favoriteEvent, triggerFavoriteEvent }}>
      {children}
    </FavoriteContext.Provider>
  );
};

export const useFavoriteEvent = () => useContext(FavoriteContext);
